import { useEffect, useState } from 'react';

const Carousel = ({ data }) => {
  const [slide, setSlide] = useState(0);

  const nextSlide = () => {
    setSlide((currentSlide) =>
      currentSlide === data.length - 1 ? 0 : currentSlide + 1
    );
  };

  const prevSlide = () => {
    setSlide(slide === 0 ? data.length - 1 : slide - 1);
  };

  useEffect(() => {
    const timerId = setInterval(() => {
      nextSlide();
    }, 4000);

    return () => clearInterval(timerId);
  }, []);

  return (
    <div className='cf-carousel'>
      <span onClick={prevSlide} className='cf-arrow cf-arrow-left'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className='cf-feather cf-feather-chevron-left'
        >
          <line x1='19' y1='12' x2='5' y2='12'></line>
          <polyline points='12 19 5 12 12 5'></polyline>
        </svg>
      </span>
      {data.map((item, idx) => {
        return (
          <div
            className={`cf-slide-content ${
              slide === idx ? 'cf-slide' : 'cf-slide-hidden'
            }`}
          >
            <img
              src={item.src}
              alt={item.alt}
              key={idx}
              width='480px'
              height='330px'
            />
          </div>
        );
      })}
      <span onClick={nextSlide} className='cf-arrow cf-arrow-right'>
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='24'
          height='24'
          viewBox='0 0 24 24'
          fill='none'
          stroke='currentColor'
          strokeWidth='2'
          strokeLinecap='round'
          strokeLinejoin='round'
          className='cf-feather cf-feather-chevron-right'
        >
          <line x1='5' y1='12' x2='19' y2='12'></line>
          <polyline points='12 5 19 12 12 19'></polyline>
        </svg>
      </span>
      <span className='cf-indicators'>
        {data.map((_, idx) => {
          return (
            <button
              key={idx}
              className={
                slide === idx
                  ? 'cf-indicator'
                  : 'cf-indicator cf-indicator-inactive'
              }
              onClick={() => setSlide(idx)}
            ></button>
          );
        })}
      </span>
    </div>
  );
};

export default Carousel;
